import { render, staticRenderFns } from "./Capacitacion.vue?vue&type=template&id=1c9d66b4&"
import script from "./Capacitacion.vue?vue&type=script&lang=js&"
export * from "./Capacitacion.vue?vue&type=script&lang=js&"
import style0 from "./Capacitacion.vue?vue&type=style&index=0&id=1c9d66b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports